export default __webpack_public_path__ + "static/media/CBF.018a09c9.webp";